module.exports = __webpack_public_path__ + "static/media/230.4435ce88.webp";